var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"homestead-exemption-calculator h-100"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col"},[_c('tax-lookup',{attrs:{"lookup-type":"owner-occupancy","disclaimer":_vm.disclaimer,"note":_vm.note,"headline":"Owner Occupancy Credit Search"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }